export default __webpack_public_path__ + "static/media/SE40.aa484649.png";